import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import cx from 'classnames';
import type { ReferencedEntry } from 'contentful';
import * as React from 'react';
import { TextStack } from '../TextStack/TextStack';
import style from './CardTextStack.module.scss';

interface ICardTextStack extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<Subject>;
  isCtaButton?: boolean;
}

export const CardTextStack: React.FC<ICardTextStack> = ({ entry, isCtaButton }) => {
  return (
    <TextStack
      className={style.cardTextStack}
      entry={entry}
      titleTagName="h3"
      titleClassName={cx(style.title)}
      blurbClassName={cx(style.blurb)}
      showLinkArrow={!isCtaButton}
      linkClassName={cx(style.cardLink, {
        btn: isCtaButton,
        [style.button]: isCtaButton,
        [style.link]: !isCtaButton,
      })}
      isButton={isCtaButton}
      buttonSize="small"
    />
  );
};
